import o from "./index198.mjs";
import t from "./index199.mjs";
import a from "./index200.mjs";
import r from "./index201.mjs";
import m from "./index202.mjs";
var n = {
  code: "zh-CN",
  formatDistance: o,
  formatLong: t,
  formatRelative: a,
  localize: r,
  match: m,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 4
  }
};
export {
  n as default
};
//# sourceMappingURL=index166.mjs.map
